export default __webpack_public_path__ + "static/anastasia-ably-c66d31e11b0ab93808cd4ef2fa2e93da.jpeg";